import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const LS_YEAR = 'eschool-academic-year';
const LS_TERM = 'eschool-term-id';

/** Global dashboard filters (openSIS-style). Drives query params on dashboard APIs. */
@Injectable({
  providedIn: 'root'
})
export class SchoolContextService {

  private readonly yearSubject: BehaviorSubject<string>;
  private readonly termSubject: BehaviorSubject<string>;

  readonly academicYears: string[] = ['2023-2024', '2024-2025', '2025-2026', '2026-2027'];
  readonly terms: { id: string; label: string }[] = [
    { id: 'Q1', label: 'Quarter 1' },
    { id: 'Q2', label: 'Quarter 2' },
    { id: 'Q3', label: 'Quarter 3' },
    { id: 'Q4', label: 'Quarter 4' }
  ];

  constructor() {
    const y = window.localStorage.getItem(LS_YEAR) || this.defaultAcademicYear();
    const t = window.localStorage.getItem(LS_TERM) || 'Q3';
    this.yearSubject = new BehaviorSubject<string>(y);
    this.termSubject = new BehaviorSubject<string>(t);
  }

  private defaultAcademicYear(): string {
    const y = new Date().getFullYear();
    return `${y}-${y + 1}`;
  }

  get academicYear$() {
    return this.yearSubject.asObservable();
  }

  get termId$() {
    return this.termSubject.asObservable();
  }

  getAcademicYear(): string {
    return this.yearSubject.value;
  }

  getTermId(): string {
    return this.termSubject.value;
  }

  setAcademicYear(v: string): void {
    window.localStorage.setItem(LS_YEAR, v);
    this.yearSubject.next(v);
  }

  setTermId(v: string): void {
    window.localStorage.setItem(LS_TERM, v);
    this.termSubject.next(v);
  }

  termLabel(id: string): string {
    return this.terms.find(t => t.id === id)?.label || id;
  }
}
